const API_CODES = {
  SUCCESS: "0",
  TOKEN_NOT_FOUND: "10",
  NOT_UNIQUE_VALIDATION: "504",
  INVALID_TOKEN: "952",
};
export default API_CODES;
